/**
 * Module to set user time on page.
 *
 * @module     report_digiboard/counttime
 * @copyright   Pimenko 2023 <support@pimenko.com> | Sylvain Revenu <crymson.gaming@gmail.com>
 * @license    http://www.gnu.org/copyleft/gpl.html GNU GPL v3 or later
 */

/**
 * This script need to be call in HTMLAdditional settings of Moodle.
 * <script type="module" src="/report/digiboard/amd/build/counttime.min.js"></script>
 * <script type="module" src="/report/digiboard/amd/build/counttime.min.js"></script>
 */
export default function counttime() {
    document.addEventListener("DOMContentLoaded", () => {
        let start = new Date().getTime();
        let totalTime = 0;
        let courseId = 0;
        let notloggedin = false;

        if (typeof document.body.classList !== 'undefined') {
            let classList = document.body.classList;

            classList.forEach(function(element) {
                if (element.match(/course-.*/)) {
                    let elementexplode = element.split("-");
                    courseId = elementexplode[1];
                }

                if (element === "notloggedin") {
                    notloggedin = true;
                }
            });
        }

        if (!notloggedin) {
            // If user change tab time will be set to db. We only track active time.
            window.addEventListener("visibilitychange", () => {

                let end = new Date().getTime();
                totalTime = (end - start) / 1000;

                // Ignore time passed on other tab.
                if (document.hidden) {
                    settimeindb(totalTime, courseId);
                }

                // Sure to reset count if send to db.
                start = new Date().getTime();

                return undefined;
            });

            // If user close tab or browser we set to db.
            window.addEventListener("beforeunload", () => {

                let end = new Date().getTime();
                totalTime = (end - start) / 1000;
                // Ignore time passed on other tab.
                settimeindb(totalTime, courseId);

                // Sure to reset count if send to db.
                start = new Date().getTime();

                return undefined;
            });

            setInterval(function() {
                let end = new Date().getTime();
                totalTime = (end - start) / 1000;
                // Ignore time passed on other tab.
                if (!document.hidden && document.hasFocus()) {
                    settimeindb(totalTime, courseId);
                }

                // Sure to reset count if send to db.
                start = new Date().getTime();
                // Timeout every 60s to be sure we save some stats bedore user close tab or browser.
            }, 60000);

        }
    });
}

/**
 * This function set time pass by ur user into the db
 * @param {int} totalTime time of the user
 * @param {int} courseId page courseId
 */
function settimeindb(totalTime, courseId) {
    require(['core/ajax'], function(Ajax) {
        let promises = Ajax.call([
            {
                methodname: 'report_digiboard_counttime',
                args: {
                    time: Math.round(totalTime),
                    courseid: courseId
                }
            },
        ]);

        promises[0].done(function(response) {
            // eslint-disable-next-line no-console
            console.debug('Time in sec ' + response);
        }).fail(function(ex) {
            // eslint-disable-next-line no-console
            console.debug(ex);
        });
    });
}

counttime();
